import * as tslib_1 from "tslib";
import { MatDialogRef } from '@angular/material';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { sentry } from 'sentry';
import { CompanyRankingService } from '../../../services/company-ranking.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var DialogConfirmDeleteCriteriasGroupComponent = /** @class */ (function () {
    function DialogConfirmDeleteCriteriasGroupComponent(data, customMessageService, companyRankingService, fuseTranslationLoaderService, matDialogRef) {
        this.data = data;
        this.customMessageService = customMessageService;
        this.companyRankingService = companyRankingService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.matDialogRef = matDialogRef;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    DialogConfirmDeleteCriteriasGroupComponent.prototype.deleteCriteriaGroup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var id, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = this.data.id;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.companyRankingService.deleteCriteriasGroupById(id)];
                    case 2:
                        _a.sent();
                        this.customMessageService.success('DIALOG_CONFIRM_DELETE_CRITERIAS_GROUP.SUCCESS');
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        this.customMessageService.error('DIALOG_CONFIRM_DELETE_CRITERIAS_GROUP.ERROR');
                        sentry.captureException(err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.matDialogRef.close(true);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return DialogConfirmDeleteCriteriasGroupComponent;
}());
export { DialogConfirmDeleteCriteriasGroupComponent };
